import Localizer from "@Scripts/Common/Localizer";
import Vue from "vue";
import Component from "vue-class-component";

@Component({ name: "MarketingFilterSelector" })
export default class MarketingFilterSelector extends Vue {
    public localizer: any = Localizer;

    public openFilter() {
        this.$store.commit("myMectronicMarketingStore/setIsFilterVisible", true);
    }
};